import HubertSelect from 'components/HubertUI/HubertSelect';
import type { ComponentProps } from 'react';
import { InterviewPropertySelectList } from './InterviewPropertySelect.constants';

interface Props extends ComponentProps<typeof HubertSelect> {
  onSelect: (e: string) => void;
  selected: string;
}

const InterviewPropertySelect = ({ onSelect, selected, ...props }: Props) => {
  return (
    <HubertSelect
      {...props}
      valuePlaceholder="Select property"
      onValueChange={(e) => {
        if (onSelect) {
          onSelect(e);
        }
      }}
      value={selected}
      list={InterviewPropertySelectList}
    />
  );
};

export default InterviewPropertySelect;
